import React from "react";
import { ShieldCheck, FileSearch, ClipboardList, Users, Building2, AlertTriangle, Lock, Scale } from "lucide-react";

const items = [
  { icon: ShieldCheck, title: "Staff identity verification", text: "Government ID verification and in-person interviews for every ParentOne team member before deployment." },
  { icon: FileSearch, title: "Background-verification workflow", text: "Structured background checks for Care Managers and field staff, renewed periodically." },
  { icon: ClipboardList, title: "Visit logs & accountability", text: "Every visit is checked in, checked out, documented and visible to the family — nothing happens off the record." },
  { icon: Users, title: "Family authorisation", text: "You control who in the family can see what, from full access to view-only and emergency-only contacts." },
  { icon: Building2, title: "Service-provider verification", text: "Hospitals, labs, nurses and ambulance partners are listed as verified only after verification is complete." },
  { icon: AlertTriangle, title: "Incident escalation", text: "A defined severity ladder — routine to emergency — with urgent incidents surfacing immediately to our operations team." },
  { icon: Lock, title: "Privacy by design", text: "Role-based access, consent-based medical data, audit trails for sensitive records, and minimal data collection." },
  { icon: Scale, title: "Honest claims only", text: "We never present a partner as verified before verification completes, and we never diagnose or treat. Clinical care stays with licensed professionals." },
];

export default function Trust() {
  return (
    <div className="p1-container py-14 lg:py-20" data-testid="trust-page">
      <p className="p1-eyebrow">Safety & Trust</p>
      <h1 className="mt-3 max-w-3xl font-heading text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl lg:text-5xl">Trust is not a feature. It's the product.</h1>
      <p className="mt-4 max-w-3xl text-lg text-stone-600">
        You are handing us the people you love most. Here is exactly how we earn that — with process, not promises.
      </p>
      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {items.map((it, i) => (
          <div key={it.title} className="p1-card p-6" data-testid={`trust-item-${i}`}>
            <it.icon className="h-7 w-7 text-emerald-800" />
            <h3 className="mt-3 font-heading text-lg font-semibold text-stone-900">{it.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-stone-600">{it.text}</p>
          </div>
        ))}
      </div>
      <div className="mt-12 rounded-3xl border border-amber-200 bg-amber-50 p-6 text-sm text-amber-900" data-testid="trust-emergency-note">
        <strong>Important:</strong> ParentOne's emergency coordination complements — and never replaces — government emergency services. In a life-threatening emergency, always call <strong>112</strong> (national emergency) or <strong>108</strong> (ambulance) first.
      </div>
    </div>
  );
}
